import { render, staticRenderFns } from "./FAQOverview.vue?vue&type=template&id=760bdf28&"
import script from "./FAQOverview.vue?vue&type=script&lang=js&"
export * from "./FAQOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FAQOverview.vue"
export default component.exports